import React, { useState, useContext, useEffect } from "react";
import "./MainSidebar.css";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import * as links from "../../../../utils/links";
import Swal from "sweetalert2";

const Sidebar = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { setDataUser, loading, authInfo } = useContext(AuthContext);
  let navigate = useNavigate();
  const { dataUser } = authInfo;
  const monitoramentoTier = String(dataUser?.monitoramentoTier || "").toUpperCase();
  const isPremiumClient =
    dataUser?.key === "CLIENT" &&
    (monitoramentoTier === "PREMIUM" ||
      location.pathname === links.DASHBOARD_FORNECEDOR_PREMIUM);
  const dashboardPath = isPremiumClient
    ? links.DASHBOARD_FORNECEDOR_PREMIUM
    : links.DASHBOARD_FORNECEDOR;
  const isDashboardActive =
    location.pathname === links.DASHBOARD_FORNECEDOR ||
    location.pathname === links.DASHBOARD_FORNECEDOR_PREMIUM;
  const isPremiumMachinesActive = location.pathname === links.MINHAS_MAQUINAS_PREMIUM;

  const comingSoon = (label) => {
    Swal.fire({
      icon: "info",
      title: label,
      text: "Função em desenvolvimento.",
      confirmButtonText: "Ok",
    });
  };

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.sidebar')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);


  return (
    <div style={{ display: 'flex' }}>
      <aside className={`sidebar ${isOpen ? "open" : ""}`}>
        <button className={`toggle ${isOpen ? "open" : ""}`} type="button" onClick={toggleOpen}>
          <i class="bi bi-chevron-right"></i>
        </button>
        <div className="inner">
          <div className="header">
            {isOpen ? (
              <img src="/logo.svg" alt="Logo" className="logo" />
            ) : (
              <button className="toggleButton" type="button" onClick={toggleOpen}>
                <i className="bi bi-list large-icon"></i>
              </button>
            )}
            <h1 className={`header-title ${isOpen ? "open" : ""}`}>{isPremiumClient ? "VendMachine" : "IK Pay system"}</h1>
          </div>
          <div className="user-card">
            <i class="bi bi-person-circle"></i>
            <span className={`user-name ${isOpen ? "open" : ""}`}>{dataUser?.name}</span>
          </div>
          <nav className="menu">
            {
              dataUser?.key === "CLIENT"
                ?
                isPremiumClient
                  ?
                  <>
                    <button className={location.pathname === links.DASHBOARD_FORNECEDOR_PREMIUM ? "active" : ""} type="button" onClick={() => navigate(links.DASHBOARD_FORNECEDOR_PREMIUM)}>
                      <i class="bi bi-speedometer2 large-icon"></i>
                      <span className="IkMenu_label">Dashboard</span>
                    </button>

                    <button className={isPremiumMachinesActive ? "active" : ""} type="button" onClick={() => navigate(links.MINHAS_MAQUINAS_PREMIUM)}>
                      <i class="bi bi-hdd-stack large-icon"></i>
                      <span className="IkMenu_label">Minhas Máquinas</span>
                    </button>

                    <button className={location.pathname === links.RELATORIOS_PREMIUM ? "active" : ""} type="button" onClick={() => navigate(links.RELATORIOS_PREMIUM)}>
                      <i class="bi bi-bar-chart large-icon"></i>
                      <span className="IkMenu_label">Relatórios</span>
                    </button>

                    <button className={location.pathname === links.FINANCEIRO_PREMIUM ? "active" : ""} type="button" onClick={() => navigate(links.FINANCEIRO_PREMIUM)}>
                      <i class="bi bi-cash-coin large-icon"></i>
                      <span className="IkMenu_label">Financeiro</span>
                    </button>

                    <button className={location.pathname === links.PROMOCOES_PREMIUM ? "active" : ""} type="button" onClick={() => navigate(links.PROMOCOES_PREMIUM)}>
                      <i class="bi bi-megaphone large-icon"></i>
                      <span className="IkMenu_label">Promoções</span>
                    </button>

                    <button className={location.pathname === links.ALERTAS_PREMIUM ? "active" : ""} type="button" onClick={() => navigate(links.ALERTAS_PREMIUM)}>
                      <i class="bi bi-bell large-icon"></i>
                      <span className="IkMenu_label">Alertas</span>
                      <span className="IkMenu_badge IkMenu_badgeCount">3</span>
                    </button>

                    <button className={location.pathname === links.ESTRATEGIAS_PREMIUM ? "active" : ""} type="button" onClick={() => navigate(links.ESTRATEGIAS_PREMIUM)}>
                      <i class="bi bi-lightbulb large-icon"></i>
                      <span className="IkMenu_label">Estratégias</span>
                      <span className="IkMenu_badge IkMenu_badgeNew">Novo</span>
                    </button>

                    <button className={location.pathname === links.PELUCIAS_PREMIUM ? "active" : ""} type="button" onClick={() => navigate(links.PELUCIAS_PREMIUM)}>
                      <i class="bi bi-gift large-icon"></i>
                      <span className="IkMenu_label">Pelúcias</span>
                    </button>

                    <button className={location.pathname === links.LOCALIZACOES_PREMIUM ? "active" : ""} type="button" onClick={() => navigate(links.LOCALIZACOES_PREMIUM)}>
                      <i class="bi bi-geo-alt large-icon"></i>
                      <span className="IkMenu_label">Localizações</span>
                    </button>

                    <button className={location.pathname === links.CONFIGURACOES_PREMIUM ? "active" : ""} type="button" onClick={() => navigate(links.CONFIGURACOES_PREMIUM)}>
                      <i class="bi bi-gear large-icon"></i>
                      <span className="IkMenu_label">Configurações</span>
                    </button>

                    <button className={location.pathname === links.CLIENTE_MENSALIDADES ? "active" : ""} type="button" onClick={() => navigate(links.CLIENTE_MENSALIDADES)}>
                      <i class="bi bi-qr-code large-icon"></i>
                      <span className="IkMenu_label">Mensalidades</span>
                    </button>

                    <button className={location.pathname === links.HELP_PAGE ? "active" : ""} type="button" onClick={() => navigate(links.HELP_PAGE)}>
                      <i class="bi bi-question-circle large-icon"></i>
                      <span className="IkMenu_label">Central de Ajuda</span>
                    </button>
                  </>
                  :
                  <button className={isDashboardActive ? "active" : ""} type="button" onClick={() => {
                    navigate(
                      dashboardPath
                    );
                  }}>
                    <i class="bi bi-hdd-stack large-icon"></i>
                    <span>Máquinas</span>
                  </button>
                :
                <>
                  {dataUser?.key === "FUNCIONARIO" ?
                    null
                    :
                    <button className={location.pathname === links.DASHBOARD_CLIENTES ? "active" : ""} type="button" onClick={() => {
                      navigate(
                        links.DASHBOARD_CLIENTES
                      );
                    }}>
                      <i class="bi bi-people large-icon"></i>
                      <span>Clientes</span>
                    </button>
                  }
                </>
            }
            {
              dataUser?.key === "FUNCIONARIO" ?
                <button className={isDashboardActive ? "active" : ""} type="button" onClick={() => {
                  navigate(
                    dashboardPath
                  );
                }}>
                  <i class="bi bi-hdd-stack large-icon"></i>
                  <span>Máquinas</span>
                </button>
                :
                ''
            }
            {
              dataUser?.key === "ADMIN" ?
                <button className={location.pathname === links.LISTA_MAQUINAS ? "active" : ""} type="button" onClick={() => {
                  navigate(
                    links.LISTA_MAQUINAS
                  );
                }}>
                  <i class="bi bi-hdd-stack large-icon"></i>
                  <span>Máquinas</span>
                </button>
                :
                ''
            }
            {
              dataUser?.key === "ADMIN" ?
                <button className={location.pathname === links.MENSALIDADES_ADM_LIST ? "active" : ""} type="button" onClick={() => {
                  navigate(
                    links.MENSALIDADES_ADM_LIST
                  );
                }}>
                  <i class="bi bi-qr-code large-icon"></i>
                  <span>Mensalidades</span>
                </button>
                :
                ''
            }
            {
              dataUser?.key === "CLIENT" && !isPremiumClient ?
                <button className={location.pathname === links.NEW_PASSWORD ? "active" : ""} type="button" onClick={() => {
                  navigate(
                    links.NEW_PASSWORD
                  );
                }}>
                  <i class="bi bi-key large-icon"></i>
                  <span>Trocar Senha</span>
                </button>
                :
                ''
            }
            {
              dataUser?.key === "CLIENT" && !isPremiumClient ?
                <button className={location.pathname === links.CLIENTE_PAGAMENTOS ? "active" : ""} type="button" onClick={() => {
                  navigate(
                    links.CLIENTE_PAGAMENTOS
                  );
                }}>
                  <i class="bi bi-credit-card-2-front large-icon"></i>
                  <span>Pagamentos</span>
                </button>
                :
                ''
            }
            {
              dataUser?.key === "CLIENT" && !isPremiumClient ?
                <button className={location.pathname === links.CLIENTE_MENSALIDADES ? "active" : ""} type="button" onClick={() => {
                  navigate(
                    links.CLIENTE_MENSALIDADES
                  );
                }}>
                  <i class="bi bi-qr-code large-icon"></i>
                  <span style={{ flexWrap: 'wrap' }}>Mensalidades</span>
                </button>
                :
                ''
            }
            <button type="button" onClick={() => {
              navigate(
                dataUser?.key === "CLIENT" || dataUser?.key === "FUNCIONARIO" ? links.SIGNIN : links.ADMIN_SIGNIN
              );
              setDataUser(null);
            }}>
              <i class="bi bi-escape large-icon"></i>
              <span>Sair</span>
            </button>
          </nav>
        </div>
      </aside>
    </div>
  );
};

export default Sidebar;
